import { fileUrlAdapter } from '@/common/filters/index.js'

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

async function download(url, name) {
  try {
    url = fileUrlAdapter(url)
    const a = document.createElement('a')
    a.download = name
    a.href = url
    a.style.display = 'none'
    document.body.appendChild(a)
    a.click()
    await delay(100)
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)
  } catch (e) {
    console.log(e)
  }
}

async function multiDownload(urls, names) {
  for (let i = 0; i < urls.length; i++) {
    await delay(i * 500)
    download(urls[i], names[i])
  }
}

export { download, multiDownload }
